import { useState } from 'react';

import { styled } from '@mui/material/styles';
import { Box, useMediaQuery, Grid } from '@mui/material';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Map from '../map/Map';
import { useTranslation } from '../common/LocalizationProvider';
import { GeofencesDialogEdit, SideBarGeofences } from '../components/geofences';
import MapGeofenceEdit from '../map/MapGeofenceEdit';

const RootStyle = styled('div')(() => ({
  flexGrow: 1
}));

const MapStyle = styled(Box)(({ theme }) => ({
  height: `calc(${window.innerHeight}px - ${95}px)`,
  width: '100%',
  position: 'relative',
  [theme.breakpoints.between('xs', 'md')]: {
    height: window.innerHeight / 1.7
  }
}));
const ContaintStyle = styled(Box)(({ theme }) => ({
  height: `calc(${window.innerHeight}px - ${95}px)`,
  overflowY: 'auto',
  overflow: 'auto',
  backgroundColor: 'rgba(255, 255, 255, 0.4)',
  backdropFilter: `blur(10px)`,
  boxShadow: 'none',
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.between('xs', 'md')]: {
    height: window.innerHeight / 2.5,
    width: window.innerWidth
  }
}));

export default function Geofences() {
  const t = useTranslation();
  const Up = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  const [selectedGeofenceId, setSelectedGeofenceId] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Page title={t('geofences_Title')}>
      <RootStyle sx={Up ? { mt: -3, mb: -10, mr: -2, ml: -2 } : { mt: -3, mb: -10 }}>
        <Scrollbar
          sx={{
            height: '100%'
          }}
        >
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
              <MapStyle>
                <Map>
                  <MapGeofenceEdit
                    selectedGeofenceId={selectedGeofenceId}
                    setSelectedGeofenceId={setSelectedGeofenceId}
                    setIsOpen={setIsOpen}
                  />
                </Map>
              </MapStyle>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
              <ContaintStyle>
                <SideBarGeofences
                  setSelectedGeofenceId={setSelectedGeofenceId}
                  setIsOpen={setIsOpen}
                />
              </ContaintStyle>
            </Grid>
          </Grid>
          {isOpen && (
            <GeofencesDialogEdit
              selectedGeofenceId={selectedGeofenceId}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />
          )}
        </Scrollbar>
      </RootStyle>
    </Page>
  );
}
